import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { breakpoints } from "../../styles/breakpoints";

export const CustomCheckingMainContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100dvh",
}));

export const CustomCheckingContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-start",
  flexDirection: "column",
  flexGrow: 1,
  padding: "var(--space-2xl)",
}));

export const CustomCheckingHeader = styled("header")(() => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "stretch",
  flexDirection: "row",
  gap: "var(--space-2xl)",
  flexWrap: "wrap",
  marginTop: "var(--space-3_75xl)",
  marginBottom: "var(--space-3_75xl)",
  maxWidth: "100%",
}));

export const CustomHeaderLeftCard = styled("div")(() => ({
  display: "flex",
  alignItems: "stretch",
  flex: "1 1 25rem",
  minWidth: "15rem",
  maxWidth: "30rem",
}));

export const HeaderCardsContainer = styled(Paper)({
  flex: "1 1 25rem",
  minWidth: "15rem",
  maxWidth: "30rem",
  borderRadius: "var(--radius-md)",
});

export const CustomHeaderOptions = styled("div")(() => ({
  display: "flex",
  flex: "1 1 100%",
  flexWrap: "wrap",
  justifyContent: "flex-start",
  gap: "var(--space-sm)",
  flexDirection: "column",
  padding: "var(--space-2xl)",
}));

export const CustomBodyContainer = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  flexWrap: "wrap",
  flexDirection: "row",
  gap: "var(--space-2xl)",
}));

export const CustomBodyContainerTables = styled("div")(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "var(--space-2xl)",
  height: "100%",
}));

export const CustomScannerBodyTables = styled("div")(() => ({
  flex: "1 1 30rem",
  minWidth: "20rem",
  outline: "none",

  "&:only-child": {
    maxWidth: "50%",
  },

  [`@media (max-width: ${breakpoints.breakpointLg})`]: {
    "&:only-child": {
      maxWidth: "100%",
    },
  },
}));
